import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { SReset } from "../../../styles/StyledMUI";
import { Box } from "@mui/joy";
import IconButtonCTA from "../../common/IconButtonCTA";
import DarkDatePicker from "../../common/DarkDatePicker";
import { colorTokens } from "../../../styles/globalStyles";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

type BirthdateComponentProps = {
  birthdate: string | null | undefined;
  setBirthdate: React.Dispatch<React.SetStateAction<string | null | undefined>>;
};

function isEmptyBirthdate(date: string | null | undefined): boolean {
  if (!date) return true;
  const day = dayjs(date);
  if (!day.isValid()) return true;
  return day.year() <= 1900;
}

export default function BirthdateComponent(props: BirthdateComponentProps) {
  const maxDate = dayjs().format("YYYY-MM-DD");
  const minDate = "1901-01-01";

  const handleDateChange = (newDate: string) => {
    if (newDate) {
      props.setBirthdate(`${newDate}T00:00:00Z`);
    } else {
      props.setBirthdate(null);
    }
  };

  const handleResetDate = () => {
    props.setBirthdate(null);
  };

  const formatInputValue = (date: string | null | undefined): string => {
    if (isEmptyBirthdate(date)) {
      return "";
    }
    return dayjs(date).format("YYYY-MM-DD");
  };

  const hasValue = !isEmptyBirthdate(props.birthdate);

  return (
    <Box sx={{ padding: 1 }}>
      <Box display="flex" alignItems="center" gap={2}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <DarkDatePicker
            value={formatInputValue(props.birthdate)}
            onChange={handleDateChange}
            max={maxDate}
            min={minDate}
            sx={{ width: "100%" }}
          />
        </Box>
        {hasValue && (
          <IconButtonCTA
            aria-label="Réinitialiser la date de naissance"
            ctaVariant="danger"
            onClick={handleResetDate}
            sx={{ flexShrink: 0 }}
          >
            <SReset iconColor={colorTokens.text.inverse} />
          </IconButtonCTA>
        )}
      </Box>
    </Box>
  );
}
